import { AlertModal, Box, Button, SubPageLayout } from "@bcc-ui/ui-components";
import { t } from "i18next";
import React from "react";

import style from "./tenant-settings-subpage.scss";
import { TenantSettingsForm } from "components/settings/views/my-settings/tenant-settings/tenant-settings-form/TenantSettingsForm";
import { Tenant } from "domain/tenants";
import { getTenantUuid } from "services/tenants/tenantCookieService";
import { tenantService } from "services/tenants/TenantService";

import testIds from "testIds.json";

export const TenantSettingsSubpage = () => {
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [isAlertModalVisible, setIsAlertModalVisible] = React.useState<boolean>(false);
    const [tenant, setTenant] = React.useState<Tenant | undefined>(undefined);

    React.useEffect(() => {
        if (tenant) {
            return;
        }

        setIsLoading(true);
        const abortController = new AbortController();
        const tenantUuid = getTenantUuid();
        tenantService
            .fetchTenant(tenantUuid, abortController)
            .then((tenantDetails) => {
                setTenant(tenantDetails);
                setIsLoading(false);
            })
            .catch(() => {
                if (!abortController.signal.aborted) {
                    setIsAlertModalVisible(true);
                    setIsLoading(false);
                }
            });

        return () => abortController.abort();
    }, [tenant]);

    return (
        <>
            <SubPageLayout
                title={""}
                loading={isLoading}
                cancelButtonLabel={t("Common.cancel")}
                hideBackArrow
                hideCancelButton
                padding="None"
                className={style.subPageLayout}
            >
                <Box columnLayout paddingTop="Sm" paddingBottom="Sm">
                    {tenant && <TenantSettingsForm tenant={tenant} />}
                </Box>
            </SubPageLayout>

            <AlertModal
                title={t("Settings.errorTitle")}
                variant={"Error"}
                buttons={
                    <Button
                        variant={"Primary"}
                        onClick={() => setIsAlertModalVisible(false)}
                        testId={testIds.common.dialog.closeButton}
                    >
                        {t("Common.ok")}
                    </Button>
                }
                isOpen={isAlertModalVisible}
                hideModal={() => setIsAlertModalVisible(false)}
            >
                {t("Common.failureMessage")}
            </AlertModal>
        </>
    );
};
